<!-- TRIGGER FIELD (form input style — matches vf-date-range-picker 'field') -->
<div
    *ngIf="variant === 'field'"
    class="vf-dp-trigger-field d-flex align-items-center border border-gray-200 rounded-8 px-12 h-40 cursor-pointer w-100 hover:border-gray-400 text-nowrap"
    #triggerEl
    (click)="open($event)"
>
    <lucide-icon name="calendar" [size]="16" class="mr-2 text-gray-500"></lucide-icon>
    <span *ngIf="!hasDate" class="f-size-14 text-gray-400">{{ placeholder }}</span>
    <span *ngIf="hasDate" class="f-size-14 text-gray-700">{{ triggerText }}</span>
    <span *ngIf="hasDate" class="vf-dp-clear-icon d-flex align-items-center ml-auto" (click)="clearInline($event)">
        <lucide-icon name="x" [size]="12" class="text-gray-400"></lucide-icon>
    </span>
</div>

<!-- TRIGGER MINIMAL (borderless) -->
<div
    *ngIf="variant === 'minimal'"
    class="vf-dp-trigger d-flex align-items-center gap-6 rounded-sm f-size-14 text-gray-500 hover:bg-gray-100 px-10 py-2 cursor-pointer text-nowrap h-36"
    #triggerEl
    (click)="open($event)"
>
    <lucide-icon name="calendar" [size]="14" class="text-gray-400"></lucide-icon>
    <span *ngIf="!hasDate" class="text-gray-500">{{ placeholder }}</span>
    <span *ngIf="hasDate">{{ triggerText }}</span>
</div>

<!-- CALENDAR — a popover under the trigger for the `field`/`minimal` variants, or dropped straight onto
     the host's own surface for `inline` (the no-date nudge, the Snooze menus). -->
<div
    *ngIf="isCalendarVisible"
    class="vf-dp-popover"
    [ngClass]="
        isInline
            ? ['vf-dp-popover--inline', fluid ? 'vf-dp-popover--fluid' : '']
            : ['vf-dp-popover--' + popoverAlign, dropDirection === 'up' ? 'vf-dp-popover--up' : '']
    "
    #popoverEl
    (click)="$event.stopPropagation()"
>
    <div class="vf-dp-calendar">
        <!-- Navigation. The label is a BUTTON: it drills days -> months -> years, so a date years back
             is three clicks rather than a long press on the arrow. The arrows page whatever level is
             showing (a month, a year, a 12-year page). -->
        <div class="vf-dp-month-nav">
            <button
                class="vf-dp-nav-btn"
                type="button"
                aria-label="Previous calendar page"
                [disabled]="!canGoPrev"
                (click)="prev()"
            >
                <lucide-icon name="chevron-left" [size]="16"></lucide-icon>
            </button>
            <button
                class="vf-dp-month-label"
                type="button"
                (click)="onHeaderClick()"
                tooltip="Choose month or year"
                container="body"
                triggers="hover"
                placement="bottom"
            >
                {{ headerLabel }}
            </button>
            <button class="vf-dp-nav-btn" type="button" aria-label="Next calendar page" (click)="next()">
                <lucide-icon name="chevron-right" [size]="16"></lucide-icon>
            </button>
        </div>

        <ng-container *ngIf="view === 'days'">
            <!-- Weekday headers -->
            <div class="vf-dp-weekdays">
                <div *ngFor="let d of weekdays" class="vf-dp-weekday-cell">{{ d }}</div>
            </div>

            <!-- Day grid -->
            <div class="vf-dp-weeks">
                <div *ngFor="let week of calendarWeeks; trackBy: trackWeek" class="vf-dp-week">
                    <button
                        *ngFor="let day of week; trackBy: trackDay"
                        type="button"
                        class="vf-dp-day"
                        [ngClass]="day.classes"
                        [attr.aria-label]="day.label"
                        [attr.aria-pressed]="day.selected"
                        [disabled]="day.disabled"
                        (click)="onDayClick(day)"
                    >
                        <span *ngIf="day.isCurrentMonth">{{ day.dayOfMonth }}</span>
                    </button>
                </div>
            </div>
        </ng-container>

        <!-- Month grid -->
        <div *ngIf="view === 'months'" class="vf-dp-cells">
            <button
                *ngFor="let cell of monthCells; trackBy: trackCell"
                type="button"
                class="vf-dp-cell"
                [class.vf-dp-cell--selected]="cell.selected"
                [class.vf-dp-cell--current]="cell.current && !cell.selected"
                [class.vf-dp-cell--disabled]="cell.disabled"
                [disabled]="cell.disabled"
                (click)="selectMonth(cell)"
            >
                {{ cell.label }}
            </button>
        </div>

        <!-- Year grid -->
        <div *ngIf="view === 'years'" class="vf-dp-cells">
            <button
                *ngFor="let cell of yearCells; trackBy: trackCell"
                type="button"
                class="vf-dp-cell"
                [class.vf-dp-cell--selected]="cell.selected"
                [class.vf-dp-cell--current]="cell.current && !cell.selected"
                [class.vf-dp-cell--disabled]="cell.disabled"
                [disabled]="cell.disabled"
                (click)="selectYear(cell)"
            >
                {{ cell.label }}
            </button>
        </div>
    </div>

    <!-- FOOTER -->
    <div class="vf-dp-footer" [class.vf-dp-footer--end]="!showToday">
        <button *ngIf="showToday" class="vf-dp-link-btn vf-dp-link-btn--today" type="button" (click)="selectToday()">Today</button>
        <button *ngIf="footerAction === 'clear'" class="vf-dp-link-btn" type="button" (click)="clearAndEmit()">
            Clear
        </button>
        <button *ngIf="footerAction === 'cancel'" class="vf-dp-link-btn" type="button" (click)="cancel()">
            Cancel
        </button>
    </div>
</div>
